import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgExploratoryDataAnalysis = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 2a10 10 0 0 1 9.2388 6.1732A10 10 0 0 1 22 12M12 2v10m0-10C6.4772 2 2 6.4772 2 12s4.4772 10 10 10 10-4.4771 10-10M12 2c5.5228 0 10 4.4772 10 10m0 0H12m10 0a10 10 0 0 1-4.1221 8.0902L12 12"
    />
  </svg>
);
export default SvgExploratoryDataAnalysis;
